<template>
    <div class="content-wrapper">
        <div class="ibox-title">
            <h5 id="h5Title">儿童体检修改</h5>
        </div>
        <div class='worker_data ibox-content' style="padding-left: 0;">
            <div class="nav_cha">体检信息</div>
            <div>
                <el-form :inline="true" :model="formInline" :rules="rules" ref="formInline" label-width="120px" label-position="right" class="demo-form-inline">
                    <el-form-item label="体检类型：" prop="mecType" style="width:350px">
                        <el-select v-model="formInline.mecType" placeholder="请选择体检类型" style="width:200px">
                            <el-option v-for="item in selectMedType" :key="item.typeId" :label="item.mecType" :value="item.typeId"  ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="体检日期：" prop='checkDate' style="width:350px">
                        <el-date-picker v-model="formInline.checkDate" value-format='yyyy-MM-dd' type="date" placeholder="选择体检日期"
                        style="width:200px" :picker-options="pickerOptions" @change="examine()"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="体检单位：" style="width:350px">
                        <el-input v-model="formInline.hospital" placeholder="体检单位" :disabled="true" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="主检医师：" style="width:350px">
                        <el-input v-model="formInline.doctor" ref="disabled" style="width:200px"></el-input>
                    </el-form-item>
                    <div class="nav_cha">儿童信息</div>
                    <el-form-item label="儿童来源：" prop="childFromType" style="width:350px">
                        <el-select v-model="formInline.childFromType" :disabled="diSchildFromType" placeholder="请选择儿童来源" style="width:200px">
                            <el-option v-for="item in selectChild" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="幼儿园：" prop="gardenName" style="width:350px">
                        <el-select v-model="formInline.gardenName" :disabled="diSgardenName" placeholder="请选择幼儿园" style="width:200px">
                            <el-option v-for="item in selectGarden" :key="item.orgKindID" :label="item.fullName" :value="item.orgKindID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="childName"  style="width:350px">
                        <el-select v-model="formInline.childName" :disabled="diSchildName" placeholder="请选择儿童" style="width:200px">
                            <el-option v-for="item in selectName" :key="item.childID" :label="item.childName" :value="item.childID"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="性别：" prop="sex" style="width:350px">
                        <el-select v-model="formInline.sex"  style="width:200px" :disabled="disSex" ref="sex">
                            <el-option key="男" label="男" value="1"></el-option>
                            <el-option key="女" label="女" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="出生日期：" prop="birthday" style="width:350px">
                        <el-date-picker v-model="formInline.birthday" value-format='yyyy-MM-dd' type="date" style="width:200px" :disabled="disBirth"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="体检年龄：" prop="birthday" style="width:350px">
                      <el-input style="width:80px" v-model="ageY" :disabled="disBirth"></el-input>岁
                      <el-input style="width:80px" v-model="ageM" :disabled="disBirth"></el-input>月
                    </el-form-item>
                    <el-form-item label="身份证号码：" prop="idCard" style="width:350px">
                        <el-input v-model="formInline.idCard" style="width:200px" :disabled="disCard" ref="idCard"></el-input>
                    </el-form-item>
                    <el-form-item label="联系人：" prop='contactPerson' style="width:350px">
                        <el-input v-model="formInline.contactPerson" style="width:200px" :disabled="disRela" ref="contactPerson"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码：" prop='relationPhone' style="width:350px">
                        <el-input v-model="formInline.relationPhone" style="width:200px" :disabled="disPhone" ref="relationPhone"></el-input>
                    </el-form-item>
                    <div class="nav_cha">一般检查</div>
                    <el-form-item label="身高：" prop="height" class="star" style="width:350px">
                        <el-input v-model.number="formInline.height"  style="width:200px" @blur="examine1()"></el-input><span>&nbsp;cm</span>
                    </el-form-item>
                    <el-form-item label="评价结果：" prop='heightComment' style="width:350px">
                        <el-input v-model="formInline.heightComment" placeholder="评价结果" style="width:200px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="体重：" prop='weight' class="star" style="width:350px" >
                        <el-input v-model.number="formInline.weight"  style="width:200px" @blur="examine2()"></el-input><span>&nbsp;kg</span>
                    </el-form-item>
                    <el-form-item label="评价结果：" prop="weightComment" style="width:350px">
                        <el-input v-model="formInline.weightComment" placeholder="评价结果" style="width:200px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="体重指数(%)：" prop='weightPercent' style="width:350px">
                        <el-input v-model="formInline.weightPercent" placeholder="体重指数" style="width:200px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="肥胖指数(%)：" prop='fatPercent' style="width:350px">
                        <el-input v-model="formInline.fatPercent" placeholder="肥胖指数" style="width:200px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="BMI：" prop='bmiValue' style="width:350px">
                        <el-input v-model="formInline.bmiValue" placeholder="BMI" style="width:200px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="综合评价：" prop='overallComment' style="width:350px">
                        <el-input v-model="formInline.overallComment" placeholder="综合评价" style="width:200px" :disabled="true"></el-input>
                    </el-form-item>
                    <!-- 一般检查中的皮肤，淋巴结，精神发育 -->
                    <el-form-item v-for='(val,num) in detailList' :key='num' :label='val.mecItemName+"："'
                    v-if='val.valueType == 3&&val.categoryId==1' style="width:541px">
                      <template v-for='(list,num) in childMecItemList' v-if='list.itemId==val.mecItemId'>
                            <template>
                                  <template v-if="list.itemResult.indexOf('_') > 0"><!--itemResult:异常_c,同时显示下拉框和input输入框-->
                                      <el-select v-model="list.itemResult.split('_')[0]" :ref="val.mecItemId" style="width:200px"
                                      @change="customizeInput($event,list,val,val.mecItemId)">
                                          <template v-for='el in val.valueOptions.split(",")'>
                                              <el-option :key='el' :label="el" :value='el'></el-option>
                                          </template>
                                      </el-select>
                                      <input :value="list.itemResult.split('_')[1]" class="el-input__inner" name="subValue"
                                      style="width:200px"  @change="changeInp($event,val,list,num)">
                                  </template>
                                  <!--itemResult:异常,显示下拉框，input输入框不显示-->
                                  <template  v-else-if="list.itemResult.indexOf('_') < 0">
                                    <el-select :ref="val.mecItemId" v-model='list.itemResult'
                                    style="width:200px" @change="customizeInput($event,list,val,val.mecItemId)">
                                        <template v-for='el in val.valueOptions.split(",")'>
                                            <el-option :key='el' :label="el" :value='el'></el-option>
                                        </template>
                                    </el-select>
                                  </template>
                              </template>
                      </template>
                  </el-form-item>
                    <!-- 其他检查中的可输入项 -->
                    <div v-for='item in CategoryList'  v-if="item.id!=1">
                        <div class="nav_cha">{{item.categoryName}}</div>
                        <el-form-item v-for='(val,num) in detailList' :key="num" :label='val.mecItemName+"："' v-if='val.categoryId==item.id' style="width:541px">
                            <template v-for='(list,num) in childMecItemList' v-if='list.itemId==val.mecItemId'>
                                <template v-if='val.unit'>
                                    <el-input v-if='val.valueType == 2 ||val.valueType == 1' v-model='list.itemResult' style="width:200px"></el-input>
                                    <span>{{val.unit}}</span>
                                </template>
                                <template v-else><!--3,4生成下拉框，1,2生成输入框-->
                                    <template v-if="val.valueType == 3||val.valueType == 4">
                                        <template v-if="list.itemResult.indexOf('_') > 0">
                                            <el-select v-model="list.itemResult.split('_')[0]" :ref="val.mecItemId" style="width:200px" @change="customizeInput($event,list,val,val.mecItemId)">
                                                <template v-for='el in val.valueOptions.split(",")'>
                                                    <el-option :key='el' :label="el" :value='el'></el-option>
                                                </template>
                                            </el-select>
                                            <input :value="list.itemResult.split('_')[1]" v-if="list.itemResult.split('_')[0]!='戴镜矫治'"
                                            class="el-input__inner" name="subValue" style="width:200px" @change="changeInp($event,val,list,num)">
                                            <!-- {{val}} -->
                                            <el-select v-model="list.itemResult.split('_')[1]"
                                             v-if="(list.itemResult.split('_')[0]=='戴镜矫治') && (val.subValue=='可疑')"
                                             v-show="selShowCreate" @change="selChange($event,list,val,num)" style="width:200px">
                                              <el-option label="远视" value="远视"></el-option>
                                              <el-option label="近视" value="近视"></el-option>
                                              <el-option label="散光" value="散光"></el-option>
                                              <el-option label="其他" value="其他"></el-option>
                                            </el-select>
                                            <el-select v-model="list.itemResult.split('_')[1]"
                                             v-else-if="list.itemResult.split('_')[0]=='戴镜矫治'"
                                             v-show="selShowCreate" @change="selChange($event,list,val,num)" style="width:200px">
                                              <el-option label="远视" value="远视"></el-option>
                                              <el-option label="近视" value="近视"></el-option>
                                              <el-option label="弱视" value="弱视"></el-option>
                                              <el-option label="斜视" value="斜视"></el-option>
                                              <el-option label="其他" value="其他"></el-option>
                                            </el-select>
                                        </template>
                                        <template v-else-if="list.itemResult.indexOf('_') <0">
                                            <el-select  :ref="val.mecItemId" v-model='list.itemResult' style="width:200px"
                                            @change="customizeInput($event,list,val,val.mecItemId)">
                                                <template v-for='el in val.valueOptions.split(",")'>
                                                    <el-option :key='el' :label="el" :value='el'></el-option>
                                                </template>
                                            </el-select>
                                            <el-select v-model="value" v-if="(list.itemResult=='戴镜矫治') && (val.subValue=='可疑')" v-show="selShow"  style="width:200px"
                                              @change="selChangeVal(val,list,value)">
                                              <el-option label="远视" value="远视"></el-option>
                                              <el-option label="近视" value="近视"></el-option>
                                              <el-option label="散光" value="散光"></el-option>
                                              <el-option label="其他" value="其他"></el-option>
                                            </el-select>
                                            <el-select v-model="value" v-else-if="(list.itemResult=='戴镜矫治') && (val.subValue !='可疑')" v-show="selShow"  style="width:200px"
                                              @change="selChangeVal(val,list,value)">
                                              <el-option label="远视" value="远视"></el-option>
                                              <el-option label="近视" value="近视"></el-option>
                                              <el-option label="弱视" value="弱视"></el-option>
                                              <el-option label="斜视" value="斜视"></el-option>
                                              <el-option label="其他" value="其他"></el-option>
                                            </el-select>
                                        </template>
                                    </template>
                                    <el-input v-if='val.valueType == 2 ||val.valueType == 1' v-model='list.itemResult' style="width:200px"
                                     @change="changeInp($event,val,list,num)"></el-input>
                                </template>
                            </template>
                        </el-form-item>
                    </div>
                    <div class="nav_gen">
                        <span class="setLine">检查结果（医院评定）</span>
                        <div class="setBtn">
                            <el-button class="btn-primary" type="primary" size='small' @click="autoGenera()">自动生成</el-button>
                        </div>
                    </div>
                    <el-form-item class="evaluate" prop="checkResult">
                        <el-input type='textarea' :rows='5' v-model="formInline.checkResult" :maxlength="200"></el-input>
                    </el-form-item>
                    <div class="nav_gen">
                        <span class="setLine">医生意见</span>
                        <div class="setBtn">
                            <el-button class="btn-primary" type="primary" size='small' @click="checkTemplate()">选用模板</el-button>
                            <el-dialog
                              width="60%"
                              title="选用模板"
                              :visible.sync="innerVisible"
                              append-to-body class="innerDialog" :before-close="handleClose" :close-on-click-modal='false'>
                              <div>
                                <div class="module_left">
                                    <p class="msgtit">疾病名称</p>
                                    <div id="dislist" style="padding: 10px 10px 10px 10px;">
                                      <el-checkbox-group
                                        v-model="checkedList" @change="checkContent">
                                        <el-checkbox v-for="illnessName in diseaseList1" :label="illnessName" :key="illnessName" style="width:100%">{{illnessName}}</el-checkbox>
                                      </el-checkbox-group>
                                      </div>
                                  </div>
                                  <div class="module_right">
                                    <p class="msgtit">模板内容</p>
                                    <div id="module_main" class="advice" v-show="moduleMain" v-html="html">
                                    </div>
                                  </div>
                                  <div style="text-align:center;">
                                      <el-button class="btn-primary" type="primary" style="margin-top:20px;" size='small' @click='confirmModule()'>确定</el-button>
                                      <el-button class="btn-primary" type="primary" style="margin-top:20px;" size='small' @click="cancel()">取消</el-button>
                                  </div>
                            </div>
                            </el-dialog>
                        </div>
                    </div>
                        <el-form-item class="evaluate" prop="doctorSuggestion">
                            <el-input type='textarea' :rows='5' v-model="formInline.doctorSuggestion" :maxlength="2000"></el-input>
                        </el-form-item>
                    <div class='hold' style="margin-top:20px">
                        <el-form-item>
                            <el-button class="btn-primary" :disabled="btnDis" type="primary" size='small' @click='submit(formInline)'>保存</el-button>
                            <el-button class="btn-primary" type="primary" size='small' @click="onReset('formInline')" v-show="setBtn">重置</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    import api from '../../com/ajax' // ajax请求封装
    import config from '../../com/config' // url配置文件
    export default {
      data () {
        var checkHeight = (rule, value, callback) => {
          if (!value) {
            return callback(new Error('请输入身高'))
          } else {
            var reg = /^[0-9]+.?[0-9]*$/
            if (!reg.test(value)) {
              callback(new Error('请输入数字'))
            } else {
              if (value < 50) {
                callback(new Error('身高不能小于50'))
              } else if (value > 160) {
                callback(new Error('身高不能大于160'))
              } else {
                callback()
              }
            }
          }
        }
        var checkWeight = (rule, value, callback) => {
          if (!value) {
            return callback(new Error('请输入体重'))
          } else {
            var reg = /^[0-9]+.?[0-9]*$/
            if (!reg.test(value)) {
              callback(new Error('请输入数字'))
            } else {
              if (value < 7) {
                callback(new Error('体重不能小于7'))
              } else if (value > 200) {
                callback(new Error('体重不能大于200'))
              } else {
                callback()
              }
            }
          }
        }
        return {
          pickerOptions: {// 只能选择今天以前的日期
            disabledDate (time) {
              return time.getTime() > Date.now() - 8.64e6
            }
          },
          sdList: [// 山东体检报告的选定模板
            {
              mecItemName: '【加强乙肝疫苗】',
              recommendation: '加强乙肝疫苗（）针'
            },
            {
              mecItemName: '【注意用眼卫生】',
              recommendation: '注意用眼卫生'
            },
            {
              mecItemName: '【注意口腔卫生】',
              recommendation: '注意口腔卫生'
            },
            {
              mecItemName: '【可以入学】',
              recommendation: '可以入学'
            }
          ],
          options: [{
            value: '远视',
            label: '远视'
          }, {
            value: '近视',
            label: '近视'
          }, {
            value: '弱视',
            label: '弱视'
          }, {
            value: '斜视',
            label: '斜视'
          }, {
            value: '其它',
            label: '其它'
          }],
          dialogTableVisible: false, // 选用模板弹窗
          popupMsg: false,
          tableData: [], // 数据表数据
          tableSelection: [], // 数据表选择数据集合
          tableSelectObj: {}, // 数据表单条选择数据对象
          tableSelectKey: '',
          tableLoading: false,
          value: '',
          formInline: {// 筛选条件表单数
            birthday: '',
            bmiValue: '',
            checkDate: '',
            checkResult: '',
            childFromType: '1',
            childID: '',
            childName: '',
            height: '',
            weight: '',
            doctor: '',
            doctorSuggestion: '',
            fatPercent: '',
            gardenId: '',
            gardenName: '',
            hospital: '',
            idCard: '',
            childMecItemList: [],
            itemResultList: [],
            mecType: '',
            overallComment: '',
            contactPerson: '',
            relationPhone: '',
            sex: '',
            weightPercent: ''
          },
          childMecItemList: [],
          diSchildFromType: false,
          diSgardenName: false,
          diSchildName: false,
          disSex: false,
          disBirth: false,
          disCard: false,
          disRela: false,
          disPhone: false,
          filter: true,
          innerVisible: false, // 选用模板出现的弹窗
          diseaseList: [], // 疾病名称
          diseaseList1: [],
          selShowCreate: true, // 带镜矫治的初始出现
          selShow: false, // 带镜矫治的下拉框隐藏
          // checked: false, // 选中疾病内容,初始为不选中
          checkedList: [], // 因为会有多个，所以用选中组
          moduleMain: false, // 选中之后，右面的内容出来
          editFormInline: '', // 修改页面进来时存储数据
          diagnoseName: '',
          illnessName: '',
          ageY:'',//年龄岁
          ageM:'',//年龄月
          recommendation: '',
          kindOrgID: '', // 幼儿园
          diseases: '', // 疾病名
          btnDis: false, // 保存按钮禁用
          html: '',
          selectMedType: [{
            'mecType': '入园体检',
            'typeId': 2
          }, {
            'mecType': '六一体检',
            'typeId': 3
          }, {
            'mecType': '自定义体检',
            'typeId': 1
          }],
          selectChild: [{
            'value': '1',
            'name': '妇保院'
          }, {
            'value': '2',
            'name': '幼儿园'
          }],
          gardenId: '',
          dataSub: {},
          opt: '',
          itemResult: '',
          selectGarden: [], // 幼儿园列表
          nationList: [], // 名族列表
          detailList: [], // 检查项目
          CategoryList: [], // 检查项目模块
          selectName: [], // 姓名列表
          getId: '', // 判断为山东账号
          valueOptions: '',
          findArr: [],
          editID: '',
          setBtn: true,
          rules: {
            mecType: [
              { required: true, message: '请输入体检类型', trigger: 'change' },
              { required: true, message: '请输入体检类型', trigger: 'blur' }
            ],
            checkDate: [
              { required: true, message: '请选择体检日期', trigger: 'change' },
              { required: true, message: '请选择体检日期', trigger: 'blur' }
            ],
            childName: [
              { required: true, message: '请输入姓名', trigger: 'change' },
              { required: true, message: '请输入姓名', trigger: 'blur' }
            ],
            sex: [
              { required: true, message: '请选择性别', trigger: 'change' },
              { required: true, message: '请选择性别', trigger: 'blur' }
            ],
            birthday: [
              { required: true, message: '请选择生日', trigger: 'change' },
              { required: true, message: '请选择生日', trigger: 'blur' }
            ],
            // idCard:[
            //     { required: false,  trigger: 'blur' },
            //     { pattern:/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/, message: '身份证号码输入格式不正确。', trigger: 'blur'}
            // ],
            height: [
              { validator: checkHeight, trigger: 'blur' }
            ],
            weight: [
              { validator: checkWeight, trigger: 'blur' }
            ]
          }
        }
      },
      methods: {
        handleClose () { // 关闭弹窗
        
          let that = this
          if (that.formInline.doctorSuggestion === '') {
            that.formInline.doctorSuggestion = ''
          } else {
            that.formInline.doctorSuggestion = that.formInline.doctorSuggestion
          }
          that.innerVisible = false
          that.diseaseList1 = []
          that.checkedList = []
        },
        selChange (event, data, val) {
          
          var getData = data.itemResult.split('_')[0]
          val.valueN = event
          data.itemResult = getData + '_' + val.valueN
        },
        selChangeVal (data, list, event) {
          
          console.log(data)
          data.valueN = event
          list.itemResult = list.itemResult + '_' + event
        },
        changeInp (event, data, list, num) {
          
          data.valueN = event.path[0].value
          this.childMecItemList[num].itemResult = this.childMecItemList[num].itemResult.split('_')[0] + '_' + event.path[0].value
        },
        customizeInput (val, list, data, id) { // 下拉框发生改变
        
          var that = this
          var dom = that.$refs[id][0].$el.offsetParent
          var input = document.createElement('input')
          input.className = 'el-input__inner'
          input.style.width = '200px'
          input.onchange = function (event) {
            data.valueN = event.path[0].value
          }
          delete data.valueN
          if (val === data.subValue||(data.subValue.indexOf(val)>-1&&data.subValue.indexOf('|')>-1)) { // 可以生成后面的
            var exist = false
            var num = 0
            
            dom.childNodes.forEach(function (i) {
              num++
              if (i.className === 'el-input__inner') {
                dom.removeChild(i)
                // exist = true
              }
            })
            if (num === dom.childNodes.length && exist === false||(data.subValue.indexOf(val)>-1&&data.subValue.indexOf('|')>-1)) {//||(data.subValue.indexOf(val)>-1&&data.subValue.indexOf('|')>-1)
              dom.append(input)
            }

            // else if(data.subValue.indexOf(val)>-1&&data.subValue.indexOf('|')>-1){
            //   dom.append(input)
            // }
          } else { // 不用生成后面的，判断是不是‘戴镜矫治’，是，生成下拉框，不是，不用生成下拉框
            let exist = false
            let allNum = 0
            let num = 0
            dom.childNodes.forEach(function (i, index) {
              allNum++
              if (i.className === 'el-input__inner') {
                exist = true
                num = index
              }
            })
            if (allNum === dom.childNodes.length && exist === true) {
              if (val === '戴镜矫治') {
                this.selShow = true
                this.value = ''
                if (dom.childNodes.length === 49) {
                  dom.removeChild(dom.childNodes[num])
                }
              } else {
                dom.removeChild(dom.childNodes[num])
              }
            }
            if (val === '戴镜矫治') {
              this.selShow = true
              this.value = ''
            }
          }
          list.itemResult = val
          
        },
        back () {
          
          var list = this.formInline
          for (var i in list) {
            list[i] = ''
          };
          this.$refs.formInline.resetFields()
          this.$emit('close', false, true)
        },
        submit (formInline) { // 提交
        
          var that = this
          var suzhou = false
          that.$refs.formInline.validate((valid) => {
            if (valid) {
              formInline.itemResultList = []
              formInline.childMecItemList = []
              for (var i = 0; i < that.detailList.length; i++) {
                if (that.detailList[i].subValue == '可疑') {
                  suzhou = true
                }
                for (var j = 0; j < that.childMecItemList.length; j++) {
                  if (that.detailList[i].mecItemId !== undefined && that.childMecItemList[j].itemId !== undefined) {
                    if (that.detailList[i].mecItemId === that.childMecItemList[j].itemId) {
                      var param1 = {
                        itemId: '',
                        itemResult: ''
                      }
                      if (!that.detailList[i].defaultValue) {
                        that.detailList[i].defaultValue = ''
                      }
                    // var val = that.detailList[i].defaultValue
                      var val = that.childMecItemList[j].itemResult
                      var maxValue = that.detailList[i].maxValue
                      var minValue = that.detailList[i].minValue
                      var decimalPlace = that.detailList[i].decimalPlace
                      var itemName = that.childMecItemList[j].itemName
                      var valueType = that.detailList[i].valueType
                      var reg = /^[0-9]+.?[0-9]*$/
                      if (valueType === 1 && val !== '' && !reg.test(val)) {
                        that.$message({
                          message: '请输入' + itemName + '体检项结果为数字！'
                        })
                        return false
                      }
                      if (decimalPlace && val.indexOf('.') > 0) {
                        var reg1 = new RegExp('^\\+?(\\d*\\.\\d{0,' + decimalPlace + '})$')
                        if (!reg1.test(val)) {
                          that.$message({
                            message: '请输入' + itemName + '体检项结果的小数位为：' + decimalPlace + '位！'
                          })
                          return false
                        }
                      }
                      if ((maxValue !== '' && parseFloat(val) > parseFloat(maxValue)) || (minValue !== '' && parseFloat(val) < parseFloat(minValue))) {
                        that.$message({
                          message: itemName + '：输入值超出[' + minValue + ', ' + maxValue + ']范围'
                        })
                        return false
                      }
                    // param1.itemId = that.childMecItemList[i].itemId
                      param1.itemId = that.childMecItemList[j].itemId
                      if (param1.itemId !== '' && param1.itemId !== undefined) {
                        if (that.detailList[i].valueN !== '' && that.detailList[i].valueN !== undefined) {
                          if (that.childMecItemList[j].itemResult.indexOf('_') < 0) {
                            param1.itemResult = that.childMecItemList[j].itemResult + '_' + that.detailList[i].valueN
                          } else {
                            if (that.childMecItemList[j].itemResult === '异常' || that.childMecItemList[j].itemResult === '其他' || that.childMecItemList[j].itemResult === '其他眼疾') {
                              param1.itemResult = that.childMecItemList[j].itemResult + '_'
                            } else {
                              param1.itemResult = that.childMecItemList[j].itemResult
                            }
                          }
                        } else if (that.childMecItemList[j].itemResult !== undefined) {
                          if (that.childMecItemList[j].itemResult === '异常' || that.childMecItemList[j].itemResult === '其他' || that.childMecItemList[j].itemResult === '其他眼疾') {
                            param1.itemResult = that.childMecItemList[j].itemResult + '_'
                          } else {
                            param1.itemResult = that.childMecItemList[j].itemResult
                          }
                          // param1.itemResult = that.childMecItemList[j].itemResult
                        }
                        if (param1.itemId === 1002) {
                          param1.itemResult = that.formInline.height
                          param1.itemComment = that.formInline.heightComment
                        } else if (param1.itemId === 1003) {
                          param1.itemResult = that.formInline.weight
                          param1.itemComment = that.formInline.weightComment
                        } else if (param1.itemId === 1006){
                          // console.log(param1)
                          let arr = param1.itemResult.split('_')
                          if(suzhou) {
                            if(arr[0] === '可疑') {
                              if((!arr[1]) || (arr[1]=== '') || (arr[1].replace(/\s+/g,"") == '')) {
                                that.$message.error('请检查视力筛查“可疑”项不能为空')
                                return false
                              }
                            }
                          }
                          if(arr[0] === '戴镜矫治') {
                            if(arr.length == 1 || arr[1] == '') {
                              that.$message.error('“视力筛查-戴镜矫治”的类型为必选')
                              return false
                            }
                          }
                        }
                        formInline.itemResultList.push(param1)
                        formInline.childMecItemList.push(param1)
                      }
                    }
                  }
                }
              }
              var param = {
                'heightValue':that.formInline.height,
                'weightValue':that.formInline.weight,
                'birthday': that.formInline.birthday || '',
                'bmiValue': that.formInline.bmiValue || '',
                'checkDate': that.formInline.checkDate || '',
                'checkResult': that.formInline.checkResult || '',
                'childFromType': that.formInline.childFromType || '',
                'childId': that.formInline.childID || '',
                'childMecItemList': that.formInline.childMecItemList || '',
                'childName': that.childName || '',
                'doctor': that.formInline.doctor || '',
                'doctorSuggestion': that.formInline.doctorSuggestion || '',
                'fatPercent': that.formInline.fatPercent || '',
                'gardenId': that.formInline.gardenId || '',
                'gardenName': that.formInline.gardenName || '',
                'hospital': that.formInline.hospital || '',
                'id': that.editID,
                'idCard': that.formInline.idCard || '',
                'itemResultList': that.formInline.itemResultList || '',
                'mecType': that.formInline.mecType || '',
                'overallComment': that.formInline.overallComment || '',
                'relation': that.formInline.contactPerson || '',
                'relationPhone': that.formInline.relationPhone || '',
                'sex': that.formInline.sex || '',
                'weightPercent': that.formInline.weightPercent || ''
              }
              api.post(config.host + 'childMec/updateChildMECInfo.do', param).then(function (response) {
                if (response.success === true) {
                  that.$message({
                    message: response.msg
                  })
                  that.back()
                }
              })
            }
          })
        },
        getData (url, param, key, hasData) {
          
          var that = this
          api.post(config.host + url, param).then(function (response) {
            if (hasData && hasData === true) {
              response.body.list.forEach(function (ele) {
                that[key].push(ele)
              })
            } else {
              that[key] = response.body.list
            }
          })
        },
        examine () { // 有身高和体重后调用参数
        
          let that = this
          var bmiIndex = Math.round(that.formInline.weight * 100 / (that.formInline.height * that.formInline.height / 10000)) / 100
          if (that.formInline.height === 'NaN') { // 为了体检日期值改变的时候身高和体重行部出现Nan的情况
            that.formInline.height = ''
          }
          if (that.formInline.weight === 'NaN') { // 为了体检日期值改变的时候身高和体重行部出现Nan的情况
            that.formInline.weight = ''
          }
          if (that.formInline.height !== '' && that.formInline.weight !== '' &&
          that.formInline.sex !== '' && that.formInline.birthday !== '' &&
          that.formInline.checkDate !== ''
          ) {
            var param = {
              'height': that.formInline.height,
              'weight': that.formInline.weight,
              'sex': that.formInline.sex,
              'birthday': that.formInline.birthday,
              'checkDate': that.formInline.checkDate
            }
            var ageParam={
              'birthday': that.formInline.birthday,
              'checkDate': that.formInline.checkDate
            }
            api.post(config.host + 'childMec/getChildAge.do', ageParam).then(function (response) {
              if(response.body.age){
                let ages=response.body.age
                ages=ages.split('.')
                that.ageY=ages[0]
                that.ageM=ages[1]
              }
            })

            api.post(config.host + 'childMec/getBodyComment.do', param).then(function (response) {
              if (response.success === true) {
                var list = response.body
                that.formInline.heightComment = list.heightComment
                that.formInline.weightComment = list.weightComment
                that.formInline.fatPercent = list.fatPerc
                that.formInline.weightPercent = list.weightPerc
                that.formInline.bmiValue = bmiIndex
                that.formInline.overallComment = list.overAllComment
              }
            })
          }
        },
        examine1 () { // 验证身高和体重标准
        
          var that = this
          that.$nextTick(() => {
            var num = Math.pow(10, 1)
            if (that.formInline.height === 'NaN'||!that.formInline.height) {
              that.formInline.height = ''
            } else {
              that.formInline.height = Number(Math.round(that.formInline.height * num) / num).toFixed(1)
            }
            that.examine()
          })
        },
        examine2 () { // 验证身高和体重标准
        
          var that = this
          that.$nextTick(() => {
            var num = Math.pow(10, 2)
            if (that.formInline.weight === 'NaN'||!that.formInline.weight) {
              that.formInline.weight = ''
            } else {
              that.formInline.weight = Number(Math.round(that.formInline.weight * num) / num).toFixed(2)
            }
            that.examine()
          })
        },
        autoGenera () { // 自动生成
        
          var that = this
          that.$refs.formInline.validate((valid) => {
            if (valid) {
              // if (that.formInline.gardenName === '') {
              //   that.$message('错误！无法生成检查结果，请在给该儿童指定“幼儿园”后再试试！')
              //   return false
              // } else {
                that.formInline.itemResultList = []
                for (var i = 0; i < that.detailList.length; i++) {
                  for (var j = 0; j < that.childMecItemList.length; j++) {
                    if (that.detailList[i].mecItemId !== undefined && that.childMecItemList[j].itemId !== undefined) {
                      if (that.detailList[i].mecItemId === that.childMecItemList[j].itemId) {
                        var param1 = {
                          itemId: '',
                          itemResult: ''
                        }
                        if (!that.detailList[i].defaultValue) {
                          that.detailList[i].defaultValue = ''
                        }
                      // var val = that.detailList[i].defaultValue
                        var val = that.childMecItemList[j].itemResult
                        var maxValue = that.detailList[i].maxValue
                        var minValue = that.detailList[i].minValue
                        var decimalPlace = that.detailList[i].decimalPlace
                        var itemName = that.childMecItemList[j].itemName
                        var valueType = that.detailList[i].valueType
                        var reg = /^[0-9]+.?[0-9]*$/
                        if (valueType === 1 && val !== '' && !reg.test(val)) {
                          that.$message({
                            message: '请输入' + itemName + '体检项结果为数字！'
                          })
                          return false
                        }
                        if (decimalPlace !== '' && val.indexOf('.') > 0) {
                          var reg1 = new RegExp('^\\+?(\\d*\\.\\d{0,' + decimalPlace + '})$')
                          if (!reg1.test(val)) {
                            that.$message({
                              message: '请输入' + itemName + '体检项结果的小数位为：' + decimalPlace + '位！'
                            })
                            return false
                          }
                        }
                        if ((maxValue !== '' && parseFloat(val) > parseFloat(maxValue)) || (minValue !== '' && parseFloat(val) < parseFloat(minValue))) {
                          that.$message({
                            message: itemName + '：输入值超出[' + minValue + ', ' + maxValue + ']范围'
                          })
                          return false
                        }
                        param1.itemId = that.childMecItemList[j].itemId
                        if (param1.itemId !== '' && param1.itemId !== undefined) {
                          if (that.detailList[i].valueN !== '' && that.detailList[i].valueN !== undefined) {
                            if (that.childMecItemList[j].itemResult.indexOf('_') < 0) {
                              param1.itemResult = that.childMecItemList[j].itemResult + '_' + that.detailList[i].valueN
                            } else {
                              if (that.childMecItemList[j].itemResult === '异常' || that.childMecItemList[j].itemResult === '其他' || that.childMecItemList[j].itemResult === '其他眼疾') {
                                param1.itemResult = that.childMecItemList[j].itemResult + '_'
                              } else {
                                param1.itemResult = that.childMecItemList[j].itemResult
                              }
                            }
                          } else if (that.childMecItemList[j].itemResult !== undefined) {
                            if (that.childMecItemList[j].itemResult === '异常' || that.childMecItemList[j].itemResult === '其他' || that.childMecItemList[j].itemResult === '其他眼疾') {
                              param1.itemResult = that.childMecItemList[j].itemResult + '_'
                            } else {
                              param1.itemResult = that.childMecItemList[j].itemResult
                            }
                          }
                          if (param1.itemId === 1002) {
                            param1.itemResult = that.formInline.height
                            param1.itemComment = that.formInline.heightComment
                          } else if (param1.itemId === 1003) {
                            param1.itemResult = that.formInline.weight
                            param1.itemComment = that.formInline.weightComment
                          }
                          that.formInline.itemResultList.push(param1)
                        }
                      }
                    }
                  }
                }
                var param = {
                  'overallComment': that.formInline.overallComment,
                  'sex': that.formInline.sex,
                  'gardenId': that.formInline.gardenId,
                  'birthday': that.formInline.birthday,
                  'checkDate': that.formInline.checkDate,
                  'itemResultList': that.formInline.itemResultList
                }
                api.post(config.host + 'childMec/getPreDiagnoseOfMECInfo.do', param).then(function (response) {
                  if (response.success === true) {
                    var list = $.parseJSON(response.body.mecItemDiagnoseList).body
                    that.diseases = ''
                    $.each(list, function (item, index) {
                      that.illnessName = index.illnessName
                      if (that.illnessName && that.diseases.indexOf(that.illnessName) < 0) {
                        that.diseases += ',' + that.illnessName
                      }
                    })
                    if (that.diseases !== '') {
                      that.formInline.checkResult = that.diseases.substring(1)
                    } else {
                      that.formInline.checkResult = '未见异常'
                    }
                  }
                })
              // }
            }
          })
        },
        close (flag) {
          
          this.dialogTableVisible = flag
        },
        checkContent (val) { // 选中疾病，生成描述
        
          let that = this
          that.html = ''
          if (that.checkedList.length > 0) {
            that.moduleMain = true
            $('#module_main').html(that.html)
            if (that.getId === '370000') {
              that.checkedList.forEach(function (i, index) {
                $.each(that.diseaseList, function (key, j) {
                  if (i === j.mecItemName) {
                    that.illnessName = j.mecItemName
                    that.recommendation = j.recommendation
                    var module = $('#module_main').html()
                    if (module.indexOf(that.illnessName) < 0) {
                      that.html += '<div><span id="checkTitle" style="font-weight: bold;display:inline-block">' + that.illnessName + '</span>' +
                      '<p style="padding-left: 10px;">' + that.recommendation + '</p></div>'
                    }
                    $('#module_main').html(that.html)
                  }
                })
              })
            } else {
              that.checkedList.forEach(function (i, index) {
                $.each(that.diseaseList, function (key, j) {
                  if (i === j.illnessName) {
                    that.illnessName = j.illnessName
                    that.recommendation = j.recommendation
                    var module = $('#module_main').html()
                    if (module.indexOf(that.illnessName) < 0) {
                      that.html += '<div><span style="font-weight: bold;display:inline-block">【' + that.illnessName + '】</span>' +
                    '<p>' + that.recommendation + '</p></div>'
                    }
                    $('#module_main').html(that.html)
                  }
                })
              })
            }
          } else {
            that.moduleMain = false
          }
        },
        confirmModule () { // 选用模板的确定按钮
        
          let that = this
          if (that.checkedList) {
            var module = $('#module_main div')
            var main = ''
            $.each(module, function () {
              var arr1 = $(this).find('p').html().split('<br>')
              var mian1 = ''
              $.each(arr1, function (i) {
                mian1 += arr1[i] + '\n' + '\n'
              })
              main += $(this).find('span').text() + mian1
            })
            that.formInline.doctorSuggestion = main
          } else {
            that.formInline.doctorSuggestion = ''
          }
          that.innerVisible = false
          that.checkedList = []
        },
        cancel () { // 选用模板的取消按钮
        
          let that = this
          if (that.formInline.doctorSuggestion === '') {
            that.formInline.doctorSuggestion = ''
          } else {
            that.formInline.doctorSuggestion = that.formInline.doctorSuggestion
          }
          that.innerVisible = false
          that.diseaseList1 = []
          that.checkedList = []
        },
        checkTemplate () { // 选用模板
        
          var that = this
          that.$refs.formInline.validate((valid) => {
            if (valid) {
              // if (that.formInline.gardenName === '') {
              //   that.$message('错误！无法生成医生建议，请在给该儿童指定“幼儿园”后再试试！')
              //   return false
              // } else {
                var flag = false
                that.formInline.itemResultList = []
                for (var i = 0; i < that.detailList.length; i++) {
                  for (var j = 0; j < that.childMecItemList.length; j++) {
                    if (that.detailList[i].mecItemId !== undefined && that.childMecItemList[j].itemId !== undefined) {
                      if (that.detailList[i].mecItemId === that.childMecItemList[j].itemId) {
                        var val = that.childMecItemList[j].itemResult
                        var maxValue = that.detailList[i].maxValue
                        var minValue = that.detailList[i].minValue
                        var decimalPlace = that.detailList[i].decimalPlace
                        var itemName = that.childMecItemList[j].itemName
                        var valueType = that.detailList[i].valueType
                        var reg = /^[0-9]+.?[0-9]*$/
                        if (valueType === 1 && val !== '' && !reg.test(val)) {
                          that.$message({
                            message: '请输入' + itemName + '体检项结果为数字！'
                          })
                          return false
                        }
                        if (decimalPlace !== '' && val.indexOf('.') > 0) {
                          var reg1 = new RegExp('^\\+?(\\d*\\.\\d{0,' + decimalPlace + '})$')
                          if (!reg1.test(val)) {
                            that.$message({
                              message: '请输入' + itemName + '体检项结果的小数位为：' + decimalPlace + '位！'
                            })
                            flag = false
                            return false
                          }
                        } else {
                          flag = true
                        }
                        if ((maxValue !== '' && parseFloat(val) > parseFloat(maxValue)) || (minValue !== '' && parseFloat(val) < parseFloat(minValue))) {
                          that.$message({
                            message: itemName + '：输入值超出[' + minValue + ', ' + maxValue + ']范围'
                          })
                          flag = false
                          return false
                        } else {
                          flag = true
                        }
                      }
                    }
                  }
                }
                if (flag === true) {
                  that.innerVisible = true
                  that.checked = false
                  that.moduleMain = false
                  that.formInline.itemResultList = []
                  for (var i = 0; i < that.detailList.length; i++) {
                    for (var j = 0; j < that.childMecItemList.length; j++) {
                      if (that.detailList[i].mecItemId !== undefined && that.childMecItemList[j].itemId !== undefined) {
                        if (that.detailList[i].mecItemId === that.childMecItemList[j].itemId) {
                          var param1 = {
                            itemId: '',
                            itemResult: ''
                          }
                          if (!that.detailList[i].defaultValue) {
                            that.detailList[i].defaultValue = ''
                          }
                          param1.itemId = that.childMecItemList[j].itemId
                          if (param1.itemId !== '' && param1.itemId !== undefined) {
                            if (that.detailList[i].valueN !== '' && that.detailList[i].valueN !== undefined) {
                              if (that.childMecItemList[j].itemResult.indexOf('_') < 0) {
                                param1.itemResult = that.childMecItemList[j].itemResult + '_' + that.detailList[i].valueN
                              } else {
                                if (that.childMecItemList[j].itemResult === '异常' || that.childMecItemList[j].itemResult === '其他' || that.childMecItemList[j].itemResult === '其他眼疾') {
                                  param1.itemResult = that.childMecItemList[j].itemResult + '_'
                                } else {
                                  param1.itemResult = that.childMecItemList[j].itemResult
                                }
                              }
                            } else if (that.childMecItemList[j].itemResult !== undefined) {
                              if (that.childMecItemList[j].itemResult === '异常' || that.childMecItemList[j].itemResult === '其他' || that.childMecItemList[j].itemResult === '其他眼疾') {
                                param1.itemResult = that.childMecItemList[j].itemResult + '_'
                              } else {
                                param1.itemResult = that.childMecItemList[j].itemResult
                              }
                            }
                            if (param1.itemId === 1002) {
                              param1.itemResult = that.formInline.height
                              param1.itemComment = that.formInline.heightComment
                            } else if (param1.itemId === 1003) {
                              param1.itemResult = that.formInline.weight
                              param1.itemComment = that.formInline.weightComment
                            }
                            that.formInline.itemResultList.push(param1)
                          }
                        }
                      }
                    }
                  }
                  var param = {
                    'overallComment': that.formInline.overallComment,
                    'sex': that.formInline.sex,
                    'gardenId': that.formInline.gardenId,
                    'birthday': that.formInline.birthday,
                    'checkDate': that.formInline.checkDate,
                    'itemResultList': that.formInline.itemResultList
                  }
                  api.post(config.host + 'childMec/getPreDiagnoseOfMECInfo.do', param).then(function (response) {
                    if (response.success === true) {
                      that.getId = response.body.provinceId
                      // 只有山东的医生建议模板是定死自己的，湖南 430000 不需要
                      if (that.getId === '370000') {
                        that.diseaseList = that.sdList
                        that.diseaseList.forEach(function (i) {
                          that.diagnoseName = i.mecItemName
                          that.illnessName = i.mecItemName
                          that.recommendation = i.recommendation
                          if (that.illnessName !== '' && that.illnessName !== undefined) {
                            if (that.diseaseList1.indexOf(that.illnessName) < 0) {
                              that.diseaseList1.push(that.illnessName)
                            }
                          }
                        })
                      } else {
                        that.diseaseList = $.parseJSON(response.body.mecItemDiagnoseList).body
                        that.diseaseList.forEach(function (i) {
                          that.diagnoseName = i.diagnoseName
                          that.illnessName = i.illnessName
                          that.recommendation = i.recommendation
                          if (that.illnessName !== '' && that.illnessName !== undefined) {
                            if (that.diseaseList1.indexOf(that.illnessName) < 0) {
                              that.diseaseList1.push(that.illnessName)
                            }
                          }
                        })
                      }
                    }
                  })
                }
              // }
            }
          })
        },
        loadInt () { // 初始化
          var that = this
          that.setBtn = true
          that.editID = that.$route.params.id
          that.diSchildFromType = true
          that.diSgardenName = true
          that.diSchildName = true
          that.disSex = true
          that.disBirth = true
          that.disCard = true
          that.disRela = true
          that.disPhone = true
          that.setBtn = false
              // 获取检查项目模块
          api.post(config.host + 'childMec/getCategoryList.do').then(function (response) {
            if (response.success === true) {
              that.CategoryList = response.body
                  // 获取检查项目模块
              api.post(config.host + 'childMec/getItemDetailList.do').then(function (response) {
                if (response.success === true) {
                  that.detailList = response.body
                  api.post(config.host + 'childMec/getChildMECDetailById.do', {'id': that.editID}).then(function (response) {
                    if (response.success === true) {
                      // that.formInline = response.body
                      if (response.body.contactPerson) {
                        that.formInline.contactPerson = response.body.contactPerson
                      } else {
                        that.formInline.contactPerson = ''
                      }
                      if(response.body.age){
                        let ages=response.body.age
                        ages=ages.split('.')
                        that.ageY=ages[0]
                        that.ageM=ages[1]
                      }
                      that.formInline.relationPhone = response.body.telphone
                      // that.gardenName = response.body.gardenName
                      // that.childName = response.body.childName
                      that.formInline.childID = response.body.childId
                      that.formInline.childFromType = response.body.childFromType + ''
                      that.childMecItemList = response.body.childMecItemList
                      that.formInline.childMecItemList = that.childMecItemList
                      // that.formInline.childMecItemList = response.body.childMecItemList
                      that.formInline.itemResultList = response.body.itemResultList
                      that.formInline.mecType = response.body.mecType
                      that.formInline.checkDate = response.body.checkDate
                      that.formInline.hospital = response.body.hospital
                      that.formInline.doctor = response.body.doctor
                      that.formInline.sex = response.body.sex
                      that.formInline.birthday = response.body.birthday
                      that.formInline.idCard = response.body.idCard
                      that.formInline.doctorSuggestion = response.body.doctorSuggestion
                      that.formInline.gardenName = response.body.gardenName
                      that.formInline.gardenId = response.body.gardenId
                      that.formInline.childName = response.body.childName
                      that.formInline.checkResult = response.body.checkResult
                      // var oldchildMecItemList = that.childMecItemList
                      var getParam = {
                        'birthday': that.formInline.birthday,
                        'childName': that.formInline.childName,
                        'sex': that.formInline.sex
                      }
                      api.post(config.host + 'child/getMECChild.do', getParam).then(function (response) {
                        if (response.success === false) {
                          that.btnDis = true
                          that.$message({
                            message: response.msg
                          })
                        }
                      })

                      that.detailList.forEach(function (i) {
                        // var exist = false
                        // var finish = false
                        var oldchildMecItemList = response.body.childMecItemList
                        oldchildMecItemList.forEach(function (j, index) {
                          if (j.itemName === '身高') {
                            that.formInline.height = j.itemResult
                          }
                          if (j.itemCode === 'heightComment') {
                            that.formInline.heightComment = j.itemResult
                          }
                          if (j.itemName === '体重') {
                            that.formInline.weight = j.itemResult
                          }
                          if (j.itemCode === 'weightComment') {
                            that.formInline.weightComment = j.itemResult
                          }
                          if (j.itemCode === 'weightPerc') {
                            that.formInline.weightPercent = j.itemResult
                          }
                          if (j.itemCode === 'fatPerc') {
                            that.formInline.fatPercent = j.itemResult
                          }
                          if (j.itemCode === 'bmiValue') {
                            that.formInline.bmiValue = j.itemResult
                          }
                          if (j.itemCode === 'overAllComment') {
                            that.formInline.overallComment = j.itemResult
                          }

                          that.formInline.childMecItemList = []
                          that.childMecItemList = []
                          that.detailList.forEach(function (i) {
                            var obj = {
                              'categoryId': i.categoryId,
                              // 'id': i.id,
                              'itemCode': i.mecItemCode,
                              'itemName': i.mecItemName,
                              'itemId': i.mecItemId,
                              // 'staffMecId': '',
                              'itemResult': i.defaultValue || ''
                            }
                            oldchildMecItemList.forEach(function (j, index) {
                              if (i.mecItemId === j.itemId) {
                                obj.itemResult = j.itemResult
                                obj.childMecId = j.childMecId
                                return false
                              };
                            })
                            that.childMecItemList.push(obj)
                            that.formInline.childMecItemList.push(obj)
                          })
                        })
                      })
                    }
                  })
                }
              })
            }
          })
        }
      },
      created () {
        var that = this
        that.loadInt()
      },
      watch: {
        $route: {
          handler: function () {
            
            var that = this
            that.loadInt()
          },
          deep: true
        }
      }
    }
</script>
<style>
    .nav_cha {
        padding-left: 10px;
        border-left: 5px solid #1ab394;
        height: 16px;
        line-height: 16px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }

    .red {
        color: red;
        position: relative;
        left: 30px;
        top: 10px
    }

    .red1 {
        color: red;
        position: relative;
        left: 15px;
        top: 10px
    }

    .red2 {
        color: red;
        position: relative;
        top: 10px
    }

    .float {
        position: absolute;
        bottom: 0px;
        right: -45px;
    }

    .evaluate {
        width: 80%;
        margin-left: 27px;
    }

    .evaluate .el-form-item__content{
        width: 100%;
    }

    .hold {
        margin: auto;
        width: 200px;
    }
    .nav_gen{
        width:82%;
        height: 46px;
        line-height: 46px;
        margin: 12px;
        font-weight: bold;
        text-align: left;
    }
    .setLine{
        padding-left: 10px;
        border-left: 5px solid #1ab394;
    }
    .setBtn{
        display: inline-block;
        float : right;
    }
    .module_left {
        height: 100%;
        float: left;
        width: 27%;
        min-height: 340px;
        border-right: 1px solid #DDDDDD;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }

    .msgtit {
        border-bottom: 1px solid #DDDDDD;
        height: 38px;
        line-height: 38px;
        font-size: 16px;
        font-weight: bold;
        padding-left: 20px;
        background: #f6f6f6;
    }

    .module_left .item {
        height: 25px;
        line-height: 25px;
        position: relative;
        padding-left: 26px;
    }
    .star .el-form-item__label:before{
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
    /* 选用模板弹窗 */
    .innerDialog .el-dialog{
      min-height:600px;
    }
    #dislist .el-checkbox{
      margin-left:0
    }
    #dislist li{
      list-style-type: none
    }
    .module_left {
        height: 100%;
        float: left;
        width: 27%;
        min-height: 340px;
        border: 1px solid #DDDDDD;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
    }
    .msgtit {
        border-bottom: 1px solid #DDDDDD;
        height: 38px;
        line-height: 38px;
        font-size: 16px;
        font-weight: bold;
        padding-left: 20px;
        background: #f6f6f6;
    }
    .module_left .item {
        height: 25px;
        line-height: 25px;
        position: relative;
        /* padding-left: 26px; */
    }
    .module_right {
        position: relative;
        float: left;
        width: 73%;
        border: 1px solid #ddd;
        border-left: none;
        min-height: 340px;
    }
    #module_main{
        padding-left:20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/physical/childPhyEdit.vue?126621f6